import React from "react";
import {autobind} from "core-decorators";
import {Select} from "antd";
import {action} from "mobx";
import {inject, observer} from "mobx-react";
import {gql} from "@apollo/client";

import "./UserRole.scss";
import {ChangeUserRole, ChangeUserRoleVariables, EnsembleUsersQuery} from "@/graphql/types";
import Store from "@/stores";

export interface IUserRoleProps {
  userEnsemble: EnsembleUsersQuery["user_ensembles"][0];
  store?: Store;
}

type Role = "conductor" | "singer";

@inject("store")
@autobind
@observer
export default class UserRole extends React.Component<IUserRoleProps> {
  async onChange(role: Role) {
    const {userEnsemble} = this.props;
    const previousRole = userEnsemble.role as Role;
    if (role === previousRole) return;
    this.setRole(role); // optimistic UI update
    try {
      const result = await this.props.store!.apollo.client.mutate<ChangeUserRole, ChangeUserRoleVariables>({
        mutation: gql`
          mutation ChangeUserRole($userEnsembleId: Int!, $role: String!) {
            user_ensemble: update_user_choirs_by_pk(pk_columns: {id: $userEnsembleId}, _set: {role: $role}) {
              id
              role
            }
          }
        `,
        variables: {
          userEnsembleId: userEnsemble.id,
          role: role,
        },
      });
      const updatedUserEnsemble = result.data?.user_ensemble;
      if (!updatedUserEnsemble) throw new Error("Could not update UserEnsemble's role");
      this.setRole(updatedUserEnsemble.role as Role);
    } catch (error) {
      this.setRole(previousRole);
      console.error(error);
    }
  }

  @action
  setRole(role: Role) {
    const {userEnsemble} = this.props;
    userEnsemble.role = role;
  }

  public render() {
    const {store, userEnsemble} = this.props;
    if (store!.session.isSelectedEnsembleOwner(userEnsemble.user.id)) return "Conductor (Owner)";
    return (
      <Select value={userEnsemble.role as Role} onChange={this.onChange} className="UserRole">
        <Select.Option value="conductor" className="UserRole--Option">
          Conductor
        </Select.Option>
        <Select.Option value="singer" className="UserRole--Option">
          Singer
        </Select.Option>
      </Select>
    );
  }
}
